export enum PortfolioRowValueKind {
	Service = "service",
	InsuranceDates = "insuranceDates",
	ValueWithChange = "valueWithChange",
	ValueOnly = "valueOnly",
	None = "none",
}
